import { useState, useEffect } from 'react';
import APIs from '../../../../../application/APIs';

interface UsePDFPageImageProps {
  templateId: string;
  currentPage: number;
  scale: number;
  ready: boolean;
}

export const usePDFPageImage = ({ templateId, currentPage, scale, ready }: UsePDFPageImageProps) => {
  const [pageImageUrl, setPageImageUrl] = useState<string | null>(null);
  const [imageLoading, setImageLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetchPageImage = async () => {
      setImageLoading(true);
      try {
        const blob = await APIs.getTemplatePDFPageBlob(templateId, currentPage, scale);
        if (!cancelled) {
          const url = URL.createObjectURL(blob);
          setPageImageUrl(prev => {
            if (prev) URL.revokeObjectURL(prev);
            return url;
          });
        }
      } catch (err) {
        console.error('Failed to load page image:', err);
      } finally {
        if (!cancelled) setImageLoading(false);
      }
    };

    if (ready) {
      fetchPageImage();
    }

    return () => {
      cancelled = true;
    };
  }, [templateId, currentPage, scale, ready]);

  return { pageImageUrl, imageLoading };
};
